import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { Checkbox } from "components/Forms"
import { boolean } from "util/selectValues";

import Sidebar from "components/Sidebar";
import { requestDeleteUser, requestUser } from 'modules/hcps/actions';
import { getQueryVariables } from 'util/index';

import { _required, _email, _mobile } from "util/validation"
let required = _required();
const requireYes = value => value === 'true' ? undefined : 'You must select "Yes" to delete the HCP.';

function mapStateToProps(state) {
  return {
    user: state.hcps.current,
  };
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    requestDeleteUser,
    requestUser
  }, dispatch);
}


class HcpDelete extends Component {

  componentWillMount() {
    const { id } = getQueryVariables(window.location.search);
    this.props.requestUser({query: id, callback: () => {
      this.props.reset();
    }});
    this.setState({ userId: id });
  }

  submit(_results) {
    return new Promise((resolve, reject) => {

      if (_results.confirmDelete !== "true") {
        return reject(new SubmissionError({
          confirmDelete: 'You must select "Yes" to delete the HCP.'
        }));
      }

      this.props.requestDeleteUser({
        id: this.props.user.id,
        callback: (result) => {
          if (!result.error) {
            this.props.history.push(`/hcp/success?type=delete`)
            return resolve();
          } else {
            return reject(new SubmissionError({
              _error: result.error.message
            }));
          }
        }
      });
    });
  }

  render() {
    if (!this.props.user.id) {
      return "";
    }
    return (
      <main className={"dashboard details-page"}>
        <Sidebar />
        <div className="content">
          <div className='default-form'>
            <h1>Delete HCP</h1>
            <p>Name: {this.props.user.firstName} {this.props.user.lastName}</p>
            <p>This will delete all the patients associated with this health care professional.</p>
              <form onSubmit={this.props.handleSubmit(results => this.submit(results))} autoComplete="off">
              <Checkbox validate={[required, requireYes]} radio title="Do you wish to continue?" styling="float r" name="confirmDelete" options={boolean} />
              <div className="navigation">
                <button type="submit" className="button-type-1">Delete</button>
              </div>
            </form>
          </div>
        </div>
      </main>
    )
  }
}

HcpDelete = reduxForm({
  form: 'HcpDelete' // a unique name for this form
})(HcpDelete);

export default connect(mapStateToProps, mapDispatchToProps)(HcpDelete);
